export const BaseConstants = {
    SCHEDULES: 'SCHEDULES',
    PRESCRIPTIONS: 'PRESCRIPTIONS',
    PARAMETERS: 'PARAMETERS'
};
